import { render, staticRenderFns } from "./AffiliateInvitationsTable.vue?vue&type=template&id=7255afb4&"
import script from "./AffiliateInvitationsTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateInvitationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateInvitationsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports